import { AriaSort, OrdemColunaTabela } from 'view/component/Tabela/model/OrdemColunaTabela';


export class Api {
  public static readonly REINO_PADRAO = 1;

  /**
   * Traduzir para o sistema de paginação do Spring Boot, no qual 
   * a primeira página é a de índice 0.
   */
  public static pageConvertion(page:number) {
    return page - 1;
  }


  public static ordemToApi(ordem?: OrdemColunaTabela) {
    return ordem === undefined || ordem.ordem === AriaSort.None
      ? ''
      : `sort=${ordem.coluna},${this.ordemConversor(ordem.ordem)}`;
  }

  private static ordemConversor(ordem: string){
    return ordem === "ascending" ? "asc" : "desc";
  }
}
